import React from "react";
import Button, { ButtonProps } from "@mui/material/Button";
import { useSharedSelector } from "../../store/SharedProvider";
import { selectIsReadOnly } from "../../store/app-configurations/app-configurations-selectors";

const ReadOnlyProtectedButton = React.forwardRef((props: ButtonProps, ref: any) => {
  const isReadOnly = useSharedSelector((state) => selectIsReadOnly(state));

  return (
    <Button
      {...props}
      ref={ref}
      disabled={props.disabled || isReadOnly}
      data-testid={props.children?.toString().replace(" ", "-") + "-test-id"}
    />
  );
});

export default ReadOnlyProtectedButton;
